import React from "react";

import CloseIcon from "@material-ui/icons/Close";
import { useIsMobile } from "../../../../components/Mui3WidthProvider";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Typography } from "@material-ui/core";
import { BuilderAsset } from "../../../../entities/BuilderAsset";

interface Props {
	disabled: boolean;
	customTemplate: BuilderAsset;
	onClose: () => void;
	onUseTemplate: () => {}
}

export function CustomTemplatePreview(props: Props) {
	const { customTemplate, disabled } = props;
	const isMobile = useIsMobile();

	return (
		<Dialog fullWidth open={true} onClose={props.onClose} fullScreen={isMobile} disableBackdropClick={disabled} disableEscapeKeyDown={disabled}>
			<DialogTitle>
				<IconButton aria-label="Close" style={{float: "right"}} onClick={props.onClose} disabled={disabled}>
					<CloseIcon />
				</IconButton>
				<Typography variant="h5">{customTemplate.name}</Typography>
				<Typography variant="body2">{customTemplate.templateDescription}</Typography>
				<DialogActions>
					<Button
						color="primary"
						style={{
							marginTop: 5,
							marginBottom: 0,
							marginLeft: "auto",
							display: "flex",
							marginRight: "auto",
						}}
						size="large"
						onClick={props.onUseTemplate}
						variant="contained"
						disabled={disabled}
					>
						Use Template
					</Button>
				</DialogActions>
			</DialogTitle>
			<Divider />
			<DialogContent>
				<span style={{WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none"}} dangerouslySetInnerHTML={{ __html: customTemplate.text }} />
			</DialogContent>
		</Dialog>
	);
}